import React, {useState} from 'react';
import ImportModal from "./importer/ImportModal";
import {useDispatch, useSelector} from "react-redux";
import {setDisplayImportModal} from "../../store/configuratorStateSlice";

const ImportElements = (props) => {
    const displayImportModal = useSelector(state => state.configuratorStateReducer.uiState.displayImportModal);
    const shapedAttributes = useSelector(state => state.productSelectionsReducer.shapedAttributes);
    const dispatch = useDispatch();

    if(shapedAttributes.length > 0) {
        return null
    }

    return (
        <div>
        <div className={'button'} onClick={() => dispatch(setDisplayImportModal(true))}>Import</div>
            <ImportModal open={displayImportModal} closeModal={() => dispatch(setDisplayImportModal(false))}/>
        </div>
    )
}

export default ImportElements;